import { useMemo } from 'react';

const INFO_GRAPH_LABELS = Array.from({ length: 180 }, (_, index) => index);

function chartData(label, data, unitPrefix) {
  return {
    labels: INFO_GRAPH_LABELS,
    datasets: [
      {
        label,
        data,
        hidden: false,
        spanGaps: true,
        tension: 0,
        cubicInterpolationMode: 'monotone',
        unitPrefix
      }
    ]
  };
}

export default function useInfoChartData(climateGraphs) {
  const humidityData = useMemo(
    () => chartData('humidity', climateGraphs.humidity, ' % RH'),
    [climateGraphs.humidity]
  );
  const temperatureData = useMemo(
    () => chartData('temp', climateGraphs.temperature, ' °C'),
    [climateGraphs.temperature]
  );

  return { humidityData, temperatureData };
}
